import { ApplicationConfig } from '@angular/core'
import { provideRouter } from '@angular/router'
import {
  provideHttpClient,
  HttpClient,
  withInterceptors,
} from '@angular/common/http'
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { HttpLoaderFactory } from './loaders/translation.loader'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { providePrimeNG } from 'primeng/config'
import { routes } from './app.routes'
import { MyPreset } from './configs/theme.config'
import { MessageService } from 'primeng/api'
import { authInterceptor } from './auth/auth-interceptor'

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: MyPreset,
      },
    }),
    provideHttpClient(),
    ...(TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }).providers || []),
    MessageService,
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
}
